<template>
	<div class="page">
		<el-row style="padding-top:20px;">
			<el-col :span="5">
				<el-input class="searchInput" placeholder="请输入关键字" v-model="search.keyword" @keyup.enter.native="clickSearch"></el-input>
				<el-button @click="clickSearch" type="primary">搜索</el-button>
			</el-col>
			<el-col :span="3" :offset="16">
				<!-- <el-button @click="clickSearch" type="success">生成报表</el-button> -->
			</el-col>
		</el-row>
		<el-row style="padding-top:20px;">
			<el-form :inline="true">
				<el-form-item label="门店">
					<el-select @change="changeSearch" v-model="search.shopId" placeholder="请选择">
						<el-option v-for="item in shops_options" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="支付方式">
					<el-select @change="changeSearch" v-model="search.payType" placeholder="请选择">
						<el-option v-for="item in payType_options" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="时间">
					<el-date-picker @change="changeSearch" v-model="datetimerange" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
					</el-date-picker>
				</el-form-item>
				<el-form-item>
					<el-button @click="clickSearch" type="success">生成报表</el-button>
				</el-form-item>
			</el-form>
			
		</el-row>
		<div class="table">
			<el-table :data="tableData" style="width: 100%">
				<el-table-column label="姓名">
					<template slot-scope="props" v-if="props.row.basic_info">
						{{props.row.basic_info.nick_name}}
					</template>
				</el-table-column>
				<el-table-column label="电话">
					<template slot-scope="props" v-if="props.row.basic_info">
						{{props.row.basic_info.user_mobile}}
					</template>
				</el-table-column>
				<el-table-column label="性别">
					<template slot-scope="props" v-if="props.row.basic_info">
						{{props.row.basic_info.sex}}
					</template>
				</el-table-column>
				<el-table-column label="宠物">
					<template slot-scope="props" v-if="props.row.pets_info">
						<div v-for="(item,index) in props.row.pets_info" :key="index">
							<div >{{item.nick_name}}</div>
						</div>
					</template>
				</el-table-column>
				<el-table-column label="余额">
					<template slot-scope="props" v-if="props.row.card_info">
						<div>{{props.row.card_info.user_yue}}</div>
					</template>
				</el-table-column>
				<el-table-column label="押金">
					<template slot-scope="props" v-if="props.row.card_info">
						<div>{{props.row.card_info.user_yajin}}</div>
					</template>
				</el-table-column>
				<el-table-column label="会员权益">
				</el-table-column>
				<el-table-column label="注册地">
					<template slot-scope="props" v-if="props.row.company_info">
						<div>{{props.row.company_info.shop_name}}</div>
					</template>
				</el-table-column>
				<el-table-column label="注册时间">
					<template slot-scope="props" v-if="props.row.operation_info">
						<div>{{$public.FTime(props.row.operation_info.create.create_time)}}</div>
					</template>
				</el-table-column>
				<el-table-column label="操作">
					<template slot-scope="props">
						<div>详情{{props.row._id}}</div>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="">
			<page :total="page.total" @change="pageChange"></page>
		</div>
	</div>
</template>
<script>
	import page from "@/components/page.vue"
	export default {
		components:{page},
		data(){
			return{
				datetimerange:[],
				search:{
					keyword:'',
					shopId:'',
					payType:-1,
					time:''
				},
				page:{
					page:1,
					pageSize:10,
					total:0
				},
				payType_options:this.$store.state.payType_options,
				shops_options:this.$store.state.userInfo.shops,
				tableData: []
			}
		},
		computed:{
		},
		mounted(){
			// this.getTableData();
		},
		methods: {
			// 搜索关键字
			clickSearch(){
				this.page.page=1;
				this.getTableData()
			},
			// 改变时间
			changeSearch(){
				this.page.page=1;
				this.getTableData()
			},
			// 改变分页
			pageChange(num){
				this.page.page=num;
				this.getTableData();
			},
			getTableData(){
				let params = {
					"shop_id": this.search.shopId,
					"hs_vip": 0,
					"hs_pet": 0,
					"class_name": "",
					"startTime": "",
					"endTime": "",
					"field": "",
					"source": "",
					"page_index": this.page.page,
					"page_size": this.page.pageSize,
					"keyword": this.search.keyword
				}
				if(this.datetimerange&&this.datetimerange.length==2){
					params.starttime=(''+new Date(this.datetimerange[0]).getTime()).substr(0,10);
					params.endtime=(''+new Date(this.datetimerange[1]).getTime()).substr(0,10);
				}
				this.$http.post('/api/VipCustomer/List', params).then(res => {
					if (res.code == 0) {
						this.tableData = res.data.data;
						this.page.total = res.data.count;
					}
				})
			},
			toogleExpand(props,scope) {
				let $table = this.$refs['table'+scope.row.id];
				$table.toggleRowExpansion(props.row, !$table.store.isRowExpanded(props.row))
			}
		}
	}
</script>
<style scoped lang="scss">
.page{
	
}
</style>
